import ColorfulMask from './colorful-mask';
export default ColorfulMask;
